/* Cristal Kitchen — scripts propios (vanilla, sin librerías) */
(function () {
  "use strict";

  // El archivo se incluye desde varias secciones; ejecutarlo una sola vez
  // evita listeners duplicados (que agregaban varias unidades al carrito).
  if (window.__mtLoaded) return;
  window.__mtLoaded = true;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("mt-visible"); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -50px 0px" });
    els.forEach(function (el, i) {
      var group = el.closest("[data-mt-stagger]");
      if (group && !el.style.getPropertyValue("--mt-delay")) {
        el.style.setProperty("--mt-delay", (Math.min(i % 6, 5) * 0.07) + "s");
      }
      obs.observe(el);
    });
  }

  /* ---------- Formato de dinero ---------- */
  function fmtMoney(cents, format) {
    var amount = cents / 100;
    var withDec = amount.toLocaleString("es-UY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = Math.round(amount).toLocaleString("es-UY", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    if (format && /\{\{/.test(format)) {
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
        return /no_decimals/.test(name) ? noDec : withDec;
      });
    }
    return "$" + withDec;
  }

  /* ---------- Toast + contador del carrito ---------- */
  var toastEl = null, toastTimer = null;
  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement("div");
    toastEl.className = "mt-toast";
    toastEl.innerHTML =
      '<span class="mt-toast__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
      '<span class="mt-toast__msg"></span>' +
      '<a href="/cart">Ver carrito</a>';
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function showToast(msg) {
    var t = ensureToast();
    t.querySelector(".mt-toast__msg").textContent = msg;
    t.classList.add("mt-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("mt-visible"); }, 4200);
  }
  function refreshCartCount() {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("#cart-icon-bubble .cart-count-bubble").forEach(function (b) {
          var s = b.querySelector("span[aria-hidden='true']");
          if (s) s.textContent = cart.item_count;
        });
        var icon = document.getElementById("cart-icon-bubble");
        if (icon && cart.item_count > 0 && !icon.querySelector(".cart-count-bubble")) {
          var d = document.createElement("div");
          d.className = "cart-count-bubble";
          d.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
          icon.appendChild(d);
        }
      })
      .catch(function () {});
  }

  /* ---------- Agregar al carrito (AJAX) — siempre 1 unidad ---------- */
  function addToCart(variantId, qty, onDone) {
    var cart = document.querySelector('cart-drawer');
    var amount = qty || 1;
    var payload = { id: variantId, quantity: amount };
    if (cart) {
      payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      payload.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (response) {
          if (!r.ok || response.status) throw new Error(response.description || 'add failed');
          return response;
        });
      })
      .then(function (response) {
        if (cart && response.sections) cart.renderContents(response);
        else refreshCartCount();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-product', productVariantId: String(variantId), cartData: response });
        }
        if (window.CKCartFeedback) window.CKCartFeedback.show(response, amount);
        if (onDone) onDone(true);
      })
      .catch(function () { if (onDone) onDone(false); });
  }

  /* ---------- Comprar ahora (agrega y va al pago) ---------- */
  function buyNow(variantId, qty) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function () { window.location.href = "/checkout"; })
      .catch(function () { window.location.href = "/cart"; });
  }

  /* ---------- Tarjetas del catálogo ---------- */
  function initCatalogo() {
    var cards = document.querySelectorAll("[data-mt-card]");
    if (!cards.length) return;
    cards.forEach(function (card) {
      if (card.dataset.mtInit) return;
      card.dataset.mtInit = "1";

      var variants;
      try { variants = JSON.parse(card.querySelector("[data-mt-card-variants]").textContent); }
      catch (e) { return; }
      var selected = variants.find(function (v) { return v.available; }) || variants[0];
      var pills = card.querySelectorAll("[data-mt-card-pill]");
      var priceEl = card.querySelector("[data-mt-card-price]");
      var addBtn = card.querySelector("[data-mt-card-add]");
      var fmt = card.getAttribute("data-money-format") || "";

      function paint() {
        pills.forEach(function (p) {
          var active = p.getAttribute("data-mt-card-pill") === String(selected.id);
          p.classList.toggle("mt-activa", active);
          p.setAttribute("aria-pressed", String(active));
        });
        if (priceEl) priceEl.textContent = fmtMoney(selected.price, fmt);
        var from = card.querySelector("[data-mt-card-from]");
        if (from) from.hidden = true;
        card.querySelectorAll("a[href]").forEach(function (link) {
          var url = new URL(link.getAttribute("href"), window.location.origin);
          if (url.pathname.indexOf("/products/") !== -1) {
            url.searchParams.set("variant", selected.id);
            link.setAttribute("href", url.pathname + url.search + url.hash);
          }
        });
        if (addBtn) addBtn.disabled = !selected.available;
      }
      pills.forEach(function (p) {
        p.addEventListener("click", function () {
          if (p.disabled) return;
          var id = p.getAttribute("data-mt-card-pill");
          var v = variants.find(function (x) { return String(x.id) === id; });
          if (v) { selected = v; paint(); }
        });
      });
      if (addBtn) {
        addBtn.addEventListener("click", function () {
          if (!selected || !selected.available) return;
          if (addBtn.dataset.mtBusy) return;
          addBtn.dataset.mtBusy = "1";
          var label = addBtn.querySelector(".mt-card__add-label");
          var prev = label ? label.textContent : "";
          if (label) label.textContent = "Agregando…";
          addToCart(selected.id, 1, function (ok) {
            delete addBtn.dataset.mtBusy;
            if (label) label.textContent = prev;
            if (!ok) showToast("No se pudo agregar. Volvé a intentarlo.");
          });
        });
      }
      if (variants.length > 1) paint();
      else if (addBtn) addBtn.disabled = !selected.available;
    });
  }

  /* ---------- Página de producto (sección MT): variantes + galería ---------- */
  function initProducto() {
    var root = document.querySelector("[data-mt-producto]");
    if (!root) return;
    if (root.dataset.mtInit) return;
    root.dataset.mtInit = "1";

    var variants;
    try { variants = JSON.parse(root.querySelector("[data-mt-variantes]").textContent); }
    catch (e) { variants = null; }

    var main = root.querySelector("[data-mt-main]");
    var videoWrap = root.querySelector("[data-mt-video]");
    var thumbs = root.querySelectorAll("[data-mt-thumb]");
    function stopVideo() {
      if (!videoWrap) return;
      videoWrap.hidden = true;
      var v = videoWrap.querySelector("video");
      if (v) { try { v.pause(); } catch (e) {} }
    }
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("mt-activa"); });
        t.classList.add("mt-activa");
        if (t.getAttribute("data-type") === "video" && videoWrap) {
          if (main) main.style.display = "none";
          videoWrap.hidden = false;
          var v = videoWrap.querySelector("video");
          if (v) { try { v.play(); } catch (e) {} }
        } else {
          stopVideo();
          if (main) {
            main.style.display = "";
            var full = t.getAttribute("data-full");
            if (full) main.src = full;
          }
        }
      });
    });

    if (!variants) return;
    var fmt = root.getAttribute("data-money-format") || "";
    var idInput = root.querySelector('input[name="id"], [data-mt-id]');
    var priceEl = root.querySelector("[data-mt-precio]");
    var priceOld = root.querySelector("[data-mt-precio-old]");
    var sizes = root.querySelectorAll("[data-mt-size]");
    var addBtn = root.querySelector("[data-mt-add]");
    var avail = root.querySelector("[data-mt-avail]");
    var selected = variants.find(function (v) { return v.available; }) || variants[0];

    function paint() {
      sizes.forEach(function (s) { s.classList.toggle("mt-activa", s.getAttribute("data-mt-size") === selected.option1); });
      if (idInput) idInput.value = selected.id;
      if (priceEl) priceEl.textContent = fmtMoney(selected.price, fmt);
      if (priceOld) {
        if (selected.compare_at_price && selected.compare_at_price > selected.price) {
          priceOld.textContent = fmtMoney(selected.compare_at_price, fmt);
          priceOld.style.display = "";
        } else { priceOld.style.display = "none"; }
      }
      if (addBtn) {
        addBtn.disabled = !selected.available;
        var lbl = addBtn.querySelector(".mt-prod__add-label");
        if (lbl) lbl.textContent = selected.available ? addBtn.getAttribute("data-ok") : addBtn.getAttribute("data-out");
      }
      if (avail) {
        avail.classList.toggle("mt-prod__avail--out", !selected.available);
        avail.querySelector("span").textContent = selected.available ? avail.getAttribute("data-ok") : avail.getAttribute("data-out");
      }
    }
    sizes.forEach(function (s) {
      s.addEventListener("click", function () {
        if (s.disabled) return;
        var val = s.getAttribute("data-mt-size");
        var v = variants.find(function (x) { return x.option1 === val && x.available; }) ||
                variants.find(function (x) { return x.option1 === val; });
        if (v) { selected = v; paint(); }
      });
    });
    if (addBtn) {
      addBtn.addEventListener("click", function (ev) {
        ev.preventDefault();
        if (!selected || !selected.available) return;
        if (addBtn.dataset.mtBusy) return;
        addBtn.dataset.mtBusy = "1";
        var lbl = addBtn.querySelector(".mt-prod__add-label");
        var prev = lbl ? lbl.textContent : "";
        if (lbl) lbl.textContent = "Agregando…";
        addToCart(selected.id, 1, function (ok) {
          delete addBtn.dataset.mtBusy;
          if (lbl) lbl.textContent = prev;
          if (!ok) showToast("No se pudo agregar. Volvé a intentarlo.");
        });
      });
    }
    var buyBtn = root.querySelector("[data-mt-buy]");
    if (buyBtn) {
      buyBtn.addEventListener("click", function (ev) {
        ev.preventDefault();
        if (!selected || !selected.available) return;
        if (buyBtn.dataset.mtBusy) return;
        buyBtn.dataset.mtBusy = "1";
        buyBtn.textContent = "Un momento…";
        buyNow(selected.id, 1);
      });
    }
    paint();
  }

  /* ---------- FAQ acordeón ---------- */
  function initFaq() {
    var items = document.querySelectorAll("[data-mt-faq]");
    items.forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = "1";
      var q = item.querySelector(".mt-faq__q");
      var a = item.querySelector(".mt-faq__a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.contains("mt-open");
        item.classList.toggle("mt-open", !open);
        a.style.maxHeight = open ? null : a.scrollHeight + "px";
      });
    });
  }

  /* ---------- Profundidad plana ----------
     Reemplaza a la vieja capa 3D. Se quitaron: la inclinación de las tarjetas
     con el mouse, el brillo que seguía al cursor, el parallax de la portada y
     la rotación de los íconos. Quedan sólo sombras y un zoom suave de imagen:
     dan calidad sin mover nada en perspectiva.
  ------------------------------------------ */
  function initProfundidad() {
    if (document.getElementById("mt-depth-styles")) return;
    var css = [
      ".mt-card{box-shadow:0 2px 4px rgba(34,28,20,.03),0 12px 26px -14px rgba(34,28,20,.10);transition:box-shadow .35s var(--ease),transform .35s var(--ease);}",
      ".mt-card:hover{box-shadow:0 8px 16px -6px rgba(34,28,20,.12),0 28px 50px -22px rgba(34,28,20,.22);transform:translateY(-4px);}",
      ".mt-card__media img,.mt-card__media .mt-card__tag{pointer-events:none;}",
      ".mt-card:hover .mt-card__media img{transform:scale(1.05);}",
      ".mt-gal__media{box-shadow:0 18px 40px -24px rgba(34,28,20,.35);transition:box-shadow .5s var(--ease);}",
      ".mt-gal__media:hover{box-shadow:0 34px 60px -30px rgba(34,28,20,.42);}",
      ".mt-benef__icon{transition:transform .35s var(--ease),box-shadow .35s var(--ease);box-shadow:0 8px 20px -12px rgba(144,86,47,.5);}",
      ".mt-benef__item:hover .mt-benef__icon{transform:translateY(-4px);box-shadow:0 16px 30px -14px rgba(144,86,47,.55);}",
      ".mt-rev__card{transition:transform .4s var(--ease),box-shadow .4s var(--ease);}",
      ".mt-rev__card:hover{transform:translateY(-5px);box-shadow:0 26px 50px -26px rgba(34,28,20,.28);}",
      "@media (prefers-reduced-motion: reduce){.mt-card,.mt-card:hover,.mt-rev__card:hover,.mt-benef__item:hover .mt-benef__icon{transform:none !important;}}",
      "@media (hover: none){.mt-card:hover{transform:none;}}"
    ].join("");
    var st = document.createElement("style");
    st.id = "mt-depth-styles";
    st.textContent = css;
    document.body.appendChild(st);
  }

  function initHeroVideo() {
    var video = document.querySelector("[data-mt-desktop-video]");
    if (!video) return;
    var source = video.querySelector("source[data-src]");
    var media = window.matchMedia("(min-width: 750px)");
    function syncVideo() {
      if (media.matches && !source.getAttribute("src")) {
        source.src = source.dataset.src;
        video.load();
        video.play().catch(function () {});
      } else if (!media.matches && source.getAttribute("src")) {
        video.pause();
        source.removeAttribute("src");
        video.load();
      }
    }
    media.addEventListener("change", syncVideo);
    syncVideo();
  }

  function initAll() {
    initHeroVideo();
    initReveals();
    initCatalogo();
    initProducto();
    initFaq();
    initProfundidad();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();


